// extracted by mini-css-extract-plugin
module.exports = {"proportionChangeContainer":"lcI4Xl1P","dateSpan":"r9S2x3qh"};